module.exports = __webpack_public_path__ + "static/img/11.69cef14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/11.jpg
// module id = H+f+
// module chunks = 1